import { render } from "./ic-link.vue?vue&type=template&id=4dbc738c&ts=true"
import script from "./ic-link.vue?vue&type=script&lang=ts"
export * from "./ic-link.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__